// Generated using scripts/write-decode-map.ts
import { decodeBase64 } from "../internal/decode-shared.js";
/** Packed XML decode trie data. */
export const xmlDecodeTree = /* #__PURE__ */ decodeBase64("AAJhZ2xxBwARABMAFQBtAg0AAAAAAA8AcAAmYG8AcwAnYHQAPmB0ADxg9SFvdCJg");
//# sourceMappingURL=decode-data-xml.js.map